// extracted by mini-css-extract-plugin
export default {"dynamicSidebar":"DynamicColorSidebar_dynamicSidebar__iCjnx"};